<template>
  <div>
    <div>
      <b-alert show variant="dark" class="margin-bottom font12px">
        <h6>Treatment & Diagnose {{ this.vnChang }}</h6>
        <b-row margin-bottom>
          <b-col lg="6">
            <b-alert
              variant="danger"
              class="margin-bottom"
              show
              v-if="this.DoctorNoteData"
            >
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>Doctor Note</strong>
                  </b-col>
                </b-row>
                <b-row
                  v-for="(item, index) in DoctorNoteData"
                  v-bind:key="item.id"
                >
                  <b-col lg="12">
                    {{ index + 1 }}. {{ item.datas.doctor_note_text }}
                    <div class="log-style">
                      Doctor : {{ item.datas.doctor_name }} | Log.
                      {{ item.datas.note_datetime }}
                    </div>
                    <hr class="hr-custom" />
                  </b-col>
                </b-row>
              </div>
            </b-alert>
            <b-alert variant="success" class="margin-bottom" show>
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>Diagnose (ICD)</strong>
                  </b-col>
                </b-row>
                <b-row v-for="item in TmpData" v-bind:key="item.id">
                  <b-col
                    >{{ item.datas.icd10 }} {{ item.datas.icd10_name }}</b-col
                  >
                </b-row>
              </div>
            </b-alert>
            <b-alert variant="warning" class="margin-bottom" show>
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>Diagnose (Text)</strong>
                  </b-col>
                </b-row>
                <b-row v-for="(item, index) in DxTextData" v-bind:key="item.id">
                  <b-col lg="12">
                    <div
                      v-html="
                        TextToHtml(index + 1 + '. ' + item.datas.diag_text)
                      "
                    ></div>
                  </b-col>
                </b-row>
              </div>
            </b-alert>
          </b-col>

          <b-col lg="6">
            <b-alert variant="primary" class="margin-bottom" show>
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>Physical Exam</strong>
                  </b-col>
                </b-row>
                <div v-if="this.ScreeningData">
                  <b-row v-if="this.ScreeningData.datas.pe_heent">
                    <b-col cols="2">HEENT</b-col>
                    <b-col cols="1">{{
                      this.ScreeningData.datas.pe_heent
                    }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_heent_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe_heart">
                    <b-col cols="2">HEART</b-col>
                    <b-col cols="1">{{
                      this.ScreeningData.datas.pe_heart
                    }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_heart_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe_lung">
                    <b-col cols="2">LUNG</b-col>
                    <b-col cols="1">{{
                      this.ScreeningData.datas.pe_lung
                    }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_lung_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe_ab">
                    <b-col cols="2">AB</b-col>
                    <b-col cols="1">{{ this.ScreeningData.datas.pe_ab }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_ab_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe_ext">
                    <b-col cols="2">EXT</b-col>
                    <b-col cols="1">{{
                      this.ScreeningData.datas.pe_ext
                    }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_ext_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe_neuro">
                    <b-col cols="2">NEURO</b-col>
                    <b-col cols="1">{{
                      this.ScreeningData.datas.pe_neuro
                    }}</b-col>
                    <b-col>{{ this.ScreeningData.datas.pe_neuro_text }}</b-col>
                  </b-row>
                  <b-row v-if="this.ScreeningData.datas.pe">
                    <b-col cols="2">PE Text :</b-col>
                    <b-col>
                      <div
                        v-html="TextToHtml(this.ScreeningData.datas.pe)"
                      ></div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-alert>
            <b-alert variant="primary" class="margin-bottom" show>
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>Physical Images</strong>
                  </b-col>
                </b-row>
                <div v-if="this.PhysicalImageData">
                  <b-row>
                    <b-col
                      v-for="(item,
                      index) in PhysicalImageData.datas.images.filter(
                        val => val
                      )"
                      v-bind:key="item.id"
                      class="margin-bottom"
                      cols="4"
                    >
                      <div v-if="item">
                        <b-modal
                          :id="'modal-physical-image' + index"
                          title="Physical Images"
                          size="xl"
                          button-size="sm"
                        >
                          <div class="text-align-center">
                            <b-img
                              rounded
                              class="image_physical_show"
                              :alt="PhysicalImageData.datas.images_note[index]"
                              :title="
                                PhysicalImageData.datas.images_note[index]
                              "
                              :src="'data:image;base64,' + item"
                              v-if="item"
                            ></b-img>
                          </div>
                          <div>
                            <h5>Note :</h5>
                            <div
                              v-html="
                                PhysicalImageData.datas.images_note[index]
                              "
                            ></div>
                          </div>

                          <template v-slot:modal-footer>
                            <div class="w-100">
                              <b-row>
                                <b-col cols="8"></b-col>
                                <b-col cols="2">
                                  <b-button
                                    variant="info"
                                    size="sm"
                                    class="float-right d-print-none"
                                    v-print="'#modal-physical-image' + index"
                                  >
                                    Print
                                  </b-button>
                                </b-col>
                                <b-col cols="2">
                                  <b-button
                                    variant="primary"
                                    size="sm"
                                    class="float-right d-print-none"
                                    @click="
                                      $bvModal.hide(
                                        'modal-physical-image' + index
                                      )
                                    "
                                  >
                                    Close
                                  </b-button>
                                </b-col>
                              </b-row>
                            </div>
                          </template>
                        </b-modal>

                        <b-img
                          rounded
                          class="img-preview-ipfs cursor-pointer"
                          :alt="PhysicalImageData.datas.images_note[index]"
                          :title="PhysicalImageData.datas.images_note[index]"
                          :src="'data:image;base64,' + item"
                          v-if="item"
                          v-b-modal="'modal-physical-image' + index"
                        ></b-img>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-alert>

            <b-alert variant="primary" class="margin-bottom" show>
              <div>
                <b-row>
                  <b-col lg="12">
                    <strong>OPD Images</strong>
                  </b-col>
                </b-row>
                <div v-if="this.OpdImageData">
                  <b-row>
                    <b-col
                      v-for="(item, index) in OpdImageData"
                      v-bind:key="item.id"
                      class="margin-bottom"
                      cols="4"
                    >
                      <b-modal
                        :id="'modal-physical-opd-image' + index"
                        title="OPD Images"
                        size="xl"
                        button-size="sm"
                      >
                        <div class="text-align-center log-style">
                          File Name : {{ item.datas.file_name_old }}
                        </div>
                        <div class="text-align-center log-style">
                          User log : {{ item.datas.file_user_name_log }}
                        </div>
                        <div class="text-align-center log-style">
                          DateTime : {{ item.datas.file_datetime }}
                        </div>
                        <div class="text-align-center">
                          <b-img
                            rounded
                            class="image_physical_show"
                            :src="'data:image;base64,' + item.datas.file_base64"
                            v-if="item"
                            :alt="
                              item.datas.file_user_name_log +
                                '\nLog.' +
                                item.datas.file_datetime
                            "
                            :title="
                              item.datas.file_user_name_log +
                                '\nLog.' +
                                item.datas.file_datetime
                            "
                          ></b-img>
                        </div>

                        <template v-slot:modal-footer>
                          <div class="w-100">
                            <b-row>
                              <b-col cols="8"></b-col>
                              <b-col cols="2">
                                <b-button
                                  variant="info"
                                  size="sm"
                                  class="float-right d-print-none"
                                  v-print="'#modal-physical-opd-image' + index"
                                >
                                  Print
                                </b-button>
                              </b-col>
                              <b-col cols="2">
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  class="float-right d-print-none"
                                  @click="
                                    $bvModal.hide(
                                      'modal-physical-opd-image' + index
                                    )
                                  "
                                >
                                  Close
                                </b-button>
                              </b-col>
                            </b-row>
                          </div>
                        </template>
                      </b-modal>

                      <b-img
                        rounded
                        class="img-preview-ipfs cursor-pointer"
                        :src="
                          'data:image;base64,' + item.datas.file_resize_base64
                        "
                        v-if="item"
                        :alt="
                          item.datas.file_user_name_log +
                            '\nLog.' +
                            item.datas.file_datetime
                        "
                        :title="
                          item.datas.file_user_name_log +
                            '\nLog.' +
                            item.datas.file_datetime
                        "
                        v-b-modal="'modal-physical-opd-image' + index"
                      ></b-img>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-alert>

            <b-alert variant="primary" class="margin-bottom" show>
              <b-row>
                <b-col lg="12">
                  <strong>OPD Images on IPFS</strong>
                </b-col>
              </b-row>

              <b-row>
                <b-col
                  class="margin-bottom"
                  cols="4"
                  v-for="(item, index) in IpfsListData"
                  v-bind:key="item.id"
                >
                  <b-modal
                    :id="'modal-ipfs-opd-image' + index"
                    title="OPD Images on IPFS"
                    size="xl"
                    hide-footer
                  >
                    <div class="text-align-center log-style">
                      File Name : {{ item.datas.ipfs_file_name }}
                    </div>
                    <div class="text-align-center log-style">
                      User log : {{ item.datas.ipfs_file_user }}
                    </div>
                    <div class="text-align-center log-style">
                      DateTime : {{ item.datas.ipfs_file_datetime }}
                    </div>
                    <div class="text-align-center margin-bottom">
                      <b-img
                        rounded
                        class="image_physical_show"
                        :src="'data:image;base64,' + item.files_base64"
                        v-if="item"
                        :alt="
                          item.file_name +
                            '\nLog.' +
                            item.datas.ipfs_file_user +
                            ' | ' +
                            item.datas.ipfs_file_datetime
                        "
                        :title="
                          item.file_name +
                            '\nLog.' +
                            item.datas.ipfs_file_user +
                            ' | ' +
                            item.datas.ipfs_file_datetime
                        "
                      ></b-img>
                    </div>

                    <div class="d-block text-center">
                      <b-button
                        variant="info"
                        size="sm"
                        class="d-print-none"
                        v-print="'#modal-ipfs-opd-image' + index"
                      >
                        Print
                      </b-button>
                      &nbsp;
                      <b-button
                        size="sm"
                        class="d-print-none"
                        @click="$bvModal.hide('modal-ipfs-opd-image' + index)"
                        >Close</b-button
                      >
                      &nbsp;
                      <b-button
                        v-if="
                          item.datas.ipfs_file_user ==
                            $store.get('systems@LoginData').UserId
                        "
                        variant="danger"
                        size="sm"
                        class="float-right d-print-none"
                        @click="IPFSImageDel(item.datas.ipfs_file_hash)"
                        >ลบ</b-button
                      >
                    </div>
                  </b-modal>

                  <b-img
                    class="img-preview-ipfs cursor-pointer"
                    center
                    :src="'data:image;base64,' + item.files_base64"
                    :alt="
                      item.file_name +
                        '\nLog.' +
                        item.datas.ipfs_file_user +
                        ' | ' +
                        item.datas.ipfs_file_datetime
                    "
                    :title="
                      item.file_name +
                        '\nLog.' +
                        item.datas.ipfs_file_user +
                        ' | ' +
                        item.datas.ipfs_file_datetime
                    "
                    v-b-modal="'modal-ipfs-opd-image' + index"
                  ></b-img>
                </b-col>
              </b-row>
              <div
                class="my-8"
                v-if="this.$store.get('systems@IPFS_USE') == 'Y'"
              >
                <image-uploader
                  id="emr-opd-image"
                  :debug="0"
                  :quality="0.9"
                  :autoRotate="true"
                  :maxWidth="1024"
                  :maxHeight="1024"
                  outputFormat="file"
                  :preview="false"
                  :className="[
                    'emr-opd-image',
                    { 'fileinput--loaded': hasImage }
                  ]"
                  :capture="false"
                  accept="image/jpeg, image/png"
                  doNotResize="['gif', 'svg']"
                  @input="setImage"
                  @onComplete="endImageResize"
                >
                  <label
                    for="emr-opd-image"
                    slot="upload-label"
                    style="width:100%;margin-bottom:0px;margin-top:4px;"
                  >
                    <figure style="margin-bottom: 0px">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 32 32"
                      >
                        <path
                          class="path1"
                          d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                        />
                      </svg>
                    </figure>
                  </label>
                </image-uploader>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-alert>
    </div>
  </div>
</template>



<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import PatientDiagOPD from "@/models/patientEMRs/PatientDiagOPD";
import PatientDiagTextOPD from "@/models/patientEMRs/PatientDiagTextOPD";
import PatientScreening from "@/models/patientEMRs/PatientScreening";
import PatientPhysicalImage from "@/models/patientEMRs/PatientPhysicalImage";
import PatientOpdImage from "@/models/patientEMRs/PatientOpdImage";
import PatientDoctorNoteOPD from "@/models/patientEMRs/PatientDoctorNoteOPD";
import PatientEmrIpfsImage from "@/models/patientEMRs/PatientEmrIpfsImage";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      vnStart: "",
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      TmpData: null,
      DxTextData: null,
      apiCk: 0,
      ScreeningData: null,
      PhysicalImageData: null,
      OpdImageData: null,
      DoctorNoteData: null,
      ptHN: "",
      ptVN: "",
      DataCh: "",
      hasImage: false,
      IpfsListData: [],
      IpfsUrl: ""
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    thaiDatetime,
    pjFunctions,
    PatientDiagOPD,
    PatientDiagTextOPD,
    PatientScreening,
    PatientPhysicalImage,
    PatientOpdImage,
    PatientDoctorNoteOPD,
    PatientEmrIpfsImage,
    PatientWebbaseUrl
  },
  created() {
    (this.thaiDatetimeFc = thaiDatetime.methods),
      (this.pjFunctionsFc = pjFunctions.methods),
      this.vnChang;
  },
  watch: {
    ptHN: function() {
      // this.setDiagOPDData(this.ptVN,this.ptHN)
      // this.setIpfsList(this.ptVN, this.ptHN);
    },
    ptVN: function() {
      this.setDiagOPDData(this.ptVN, this.ptHN);
      // this.setIpfsList(this.ptVN, this.ptHN);
    },
    DataCh: function() {
      this.getDiagOPDData(this.ptVN, this.ptHN);
    }
  },
  computed: {
    vnChang() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    }
  },
  methods: {
    printImage(PrintID) {
      // Pass the element id here
      this.$htmlToPaper(PrintID);
    },
    setImage: function(output) {
      this.hasImage = true;
      this.image = output;
      // console.log(this.image.data);
    },
    endImageResize() {
      let Obj2 = this;
      let filesAddAtd = false;

      let formData = new FormData();

      formData.append("token_key", this.$store.get("systems@token_key"));
      formData.append("file_user", this.$store.get("systems@LoginData").UserId);

      formData.append("CompanyId", this.$store.get("systems@CompanyId"));
      formData.append("ApiKey", this.$store.get("systems@ApiKey"));
      formData.append("ipfs_action", "files-add-files");

      formData.append("key1", "emr-opd-image");
      formData.append("key2", "");
      formData.append("key3", "");
      formData.append("vn", this.ptVN);
      formData.append("hn", this.ptHN);
      formData.append("files", this.image);

      this.axios
        .post(this.$store.get("systems@UrlApi") + "Call-IPFS-files", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          Obj2.output = response.data;

          if (Obj2.output.status === true) {
            filesAddAtd = true;
          } else {
            filesAddAtd = false;
          }
        })
        .catch(function(error) {
          Obj2.output = error;
          console.log("files-add : " + Obj2.output);
        })
        .finally(function() {
          // console.log("OPOPO", Obj2.output.result);
          Obj2.ImageInsert(Obj2.output.result);
          // Obj2.DataCh = "files-add" + vn;
        });
    },

    IPFSImageDel(hash) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm("ยืนยันการลบรูปภาพ. !", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            let ScrObj = this;
            this.axios
              .post(this.$store.get("systems@UrlApi") + "Call-IPFS-files-rm", {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                ipfs_action: "files-remove",
                file_user: this.$store.get("systems@LoginData").UserId,
                hn: this.ptHN,
                vn: this.ptVN,
                key1: "emr-opd-image",
                key2: "",
                key3: "",
                token_key: this.$store.get("systems@token_key"),
                hash: hash
              })
              .then(function(response) {
                ScrObj.output = response.data;
                if (ScrObj.output.status === true) {
                  // ddd
                } else {
                  // console.log('EmrIpfsImageAdd : '+ScrObj.output.ErrorMessage)
                }
              })
              .catch(function(error) {
                ScrObj.output = error;
                console.log("EmrIpfsImageDel : " + ScrObj.output);
              })
              .finally(function() {
                ScrObj.setIpfsList(ScrObj.ptVN, ScrObj.ptHN);
              });
          }
        });
    },

    ImageInsert(datas) {
      let SendData = datas[0];
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrIpfsImageAdd", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: this.ptHN,
          vn: this.ptVN,
          ipfs_file_hash: SendData.ipfs_file_hash,
          key1: SendData.key1,
          key2: SendData.key2,
          key3: SendData.key3,
          ipfs_token_key: SendData.ipfs_token_key,
          ipfs_file_name: SendData.ipfs_file_name,
          ipfs_file_type: SendData.ipfs_file_type,
          ipfs_file_extension: SendData.ipfs_file_extension
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            // ddd
          } else {
            // console.log('EmrIpfsImageAdd : '+ScrObj.output.ErrorMessage)
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("EmrIpfsImageAdd : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.setIpfsList(ScrObj.ptVN, ScrObj.ptHN);
        });
    },
    setDiagOPDData(vn, hn) {
      this.DataCh = "StartPatientPhysicalImage" + vn;

      if (vn != "" && vn != null) {
        let hnCk = hn;

        /*
        let VitalSignObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "VisitOPDVitalSign", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            VitalSignObj.output = response.data;
            if (VitalSignObj.output.status === true) {
              PatientScreening.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of VitalSignObj.output.result) {
                data.push({
                  id: val.vn,
                  vn: val.vn,
                  hn: val.hn,
                  datas: val
                });
              }

              PatientScreening.insertOrUpdate({
                data
              });
            } else {
              if (VitalSignObj.output.ErrorMessage === "Data Not Found") {
                PatientScreening.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            VitalSignObj.output = error;
            console.log("VisitOPDVitalSign : " + VitalSignObj.output);
          })
          .finally(function() {
            VitalSignObj.ScreeningDataCh = "VisitOPDVitalSign" + vn;
          });
        
        */

        let ScrObj = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DiagOPD", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            ScrObj.output = response.data;
            if (ScrObj.output.status === true) {
              PatientDiagOPD.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of ScrObj.output.result) {
                data.push({
                  id: val.diag_id,
                  diag_id: val.diag_id,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientDiagOPD.insertOrUpdate({
                data
              });
            } else {
              if (ScrObj.output.ErrorMessage === "Data Not Found") {
                PatientDiagOPD.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            ScrObj.output = error;
            console.log("DiagOPD : " + ScrObj.output);
          })
          .finally(function() {
            ScrObj.DataCh = "DiagOPD" + vn;
          });

        let Obj2 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DiagTextOPD", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            Obj2.output = response.data;
            if (Obj2.output.status === true) {
              PatientDiagTextOPD.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of Obj2.output.result) {
                data.push({
                  id: val.ovst_doctor_diag_id,
                  ovst_doctor_diag_id: val.ovst_doctor_diag_id,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientDiagTextOPD.insertOrUpdate({
                data
              });
            } else {
              if (Obj2.output.ErrorMessage === "Data Not Found") {
                PatientDiagTextOPD.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            Obj2.output = error;
            console.log("DiagTextOPD : " + Obj2.output);
          })
          .finally(function() {
            Obj2.DataCh = "DiagTextOPD" + vn;
          });

        let Obj3 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientPhysicalImage", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            Obj3.output = response.data;
            if (Obj3.output.status === true) {
              PatientPhysicalImage.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              PatientPhysicalImage.insertOrUpdate({
                data: {
                  id: Obj3.output.result.vn,
                  hn: Obj3.output.result.hn,
                  vn: Obj3.output.result.vn,
                  datas: Obj3.output.result
                }
              });
            } else {
              // console.log('PatientPhysicalImage : '+Obj3.output.ErrorMessage)
              if (Obj3.output.ErrorMessage === "Data Not Found") {
                PatientPhysicalImage.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            Obj3.output = error;
            console.log("PatientPhysicalImage : " + Obj3.output);
          })
          .finally(function() {
            Obj3.DataCh = "PatientPhysicalImage" + vn;
          });

        let Obj4 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "PatientOpdImage", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            Obj4.output = response.data;
            if (Obj4.output.status === true) {
              PatientOpdImage.delete({
                where(record) {
                  return record.vn == vn;
                }
              });

              let data = [];
              for (var val of Obj4.output.result) {
                data.push({
                  id: val.file_id,
                  file_id: val.file_id,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientOpdImage.insertOrUpdate({
                data
              });
            } else {
              if (Obj4.output.ErrorMessage === "Data Not Found") {
                PatientOpdImage.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            Obj4.output = error;
            console.log("PatientOpdImage : " + Obj4.output);
          })
          .finally(function() {
            Obj4.DataCh = "PatientOpdImage" + vn;
          });

        let Obj5 = this;
        this.axios
          .post(this.$store.get("systems@UrlApi") + "DoctorNoteData", {
            CompanyId: this.$store.get("systems@CompanyId"),
            ApiKey: this.$store.get("systems@ApiKey"),
            hn: hn,
            vn: vn
          })
          .then(function(response) {
            Obj5.output = response.data;
            if (Obj5.output.status === true) {
              PatientDoctorNoteOPD.delete({
                where(record) {
                  return record.hn == hnCk;
                }
              });

              let data = [];
              for (var val of Obj4.output.result) {
                data.push({
                  id: val.patient_visit_doctor_note_id,
                  patient_visit_doctor_note_id:
                    val.patient_visit_doctor_note_id,
                  hn: val.hn,
                  vn: val.vn,
                  datas: val
                });
              }

              PatientDoctorNoteOPD.insertOrUpdate({
                data
              });
            } else {
              if (Obj5.output.ErrorMessage === "Data Not Found") {
                PatientDoctorNoteOPD.delete({
                  where(record) {
                    return record.hn == hnCk;
                  }
                });
              }
            }
          })
          .catch(function(error) {
            Obj5.output = error;
            console.log("DoctorNoteData : " + Obj5.output);
          })
          .finally(function() {
            Obj5.DataCh = "DoctorNoteData" + vn;
          });

        this.setIpfsList(vn, hn);
      }
    },
    setIpfsList(vn, hn) {
      let Obj6 = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "EmrIpfsImageGet", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          vn: vn
        })
        .then(function(response) {
          Obj6.output = response.data;
          if (Obj6.output.status === true) {
            PatientEmrIpfsImage.delete({
              where(record) {
                return record.vn == vn;
              }
            });

            let data = [];
            for (var val of Obj6.output.result) {
              data.push({
                id: val.ipfs_file_hash + val.ipfs_file_user,
                ipfs_file_user: val.ipfs_file_user,
                vn: val.vn,
                hn: val.hn,
                key1: val.key1,
                key2: val.key2,
                key3: val.key3,
                datas: val
              });
            }

            PatientEmrIpfsImage.insertOrUpdate({
              data
            });
          } else {
            // console.log('EmrIpfsImageGet : '+Obj5.output.ErrorMessage)
            if (Obj6.output.ErrorMessage === "Data Not Found") {
              PatientEmrIpfsImage.delete({
                where(record) {
                  return record.vn == vn;
                }
              });
            }
          }
        })
        .catch(function(error) {
          Obj6.output = error;
          console.log("EmrIpfsImageGet : " + Obj6.output);
        })
        .finally(function() {
          Obj6.getIpfsList(Obj6.ptVN, Obj6.ptHN);
        });
    },
    getIpfsList(vn, hn) {
      let IpfsUrlObj = PatientWebbaseUrl.query()
        .where(record => record.web_name == "IPFS-S1")
        .where(record => record.datas.web_status == "Y")
        .get();

      if (IpfsUrlObj.length > 0) {
        this.IpfsUrl = IpfsUrlObj[0].web_host;
      }

      let ScrObj = PatientEmrIpfsImage.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .where(record => record.key1 == "emr-opd-image")
        .get();

      if (ScrObj.length > 0) {
        this.IpfsListData = [];
        let Obj2 = this;
        let datas = [];
        let n = 0;
        let result = null;
        let dd = null;
        for (var val of ScrObj) {
          dd = {
            ipfs_file_user: val.datas.ipfs_file_user,
            ipfs_file_name: val.datas.ipfs_file_name,
            ipfs_file_datetime: val.datas.ipfs_file_datetime,
            vn: val.datas.vn,
            hn: val.datas.hn,
            key1: val.datas.key1,
            key2: val.datas.key2,
            key3: val.datas.key3,
            ipfs_file_hash: val.datas.ipfs_file_hash
          };

          this.axios
            .post(
              this.$store.get("systems@UrlApi") + "Call-IPFS-files-get-base64",
              {
                CompanyId: this.$store.get("systems@CompanyId"),
                ApiKey: this.$store.get("systems@ApiKey"),
                token_key: this.$store.get("systems@token_key"),
                hash: val.datas.ipfs_file_hash,
                datas: dd
              }
            )
            .then(function(response) {
              Obj2.output = response.data;
              if (Obj2.output.status === true) {
                Obj2.IpfsListData.push({
                  file_name: Obj2.output.result.file_name,
                  files_base64: Obj2.output.result.files_base64,
                  ipfs_file_user: Obj2.output.result.datas.ipfs_file_user,
                  vn: Obj2.output.result.datas.vn,
                  hn: Obj2.output.result.datas.hn,
                  key1: Obj2.output.result.datas.key1,
                  key2: Obj2.output.result.datas.key2,
                  key3: Obj2.output.result.datas.key3,
                  datas: Obj2.output.result.datas
                });
              }
            })
            .catch(function(error) {
              Obj2.output = error;
              console.log("files-get : " + Obj2.output);
            })
            .finally(function() {
              // console.log("ddd", Obj2.IpfsListData);
            });
        }
      } else {
        this.IpfsListData = [];
      }
    },
    getDiagOPDData(vn, hn) {
      let ScrObj = PatientDiagOPD.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (ScrObj.length > 0) {
        this.TmpData = ScrObj;
        this.apiCk = this.apiCk + 1;
      } else {
        this.TmpData = null;
        this.apiCk = this.apiCk + 1;
      }

      let Obj3 = PatientDiagTextOPD.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (Obj3.length > 0) {
        this.DxTextData = Obj3;
        this.apiCk = this.apiCk + 1;
      } else {
        this.DxTextData = null;
        this.apiCk = this.apiCk + 1;
      }

      let Obj4 = PatientScreening.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (Obj4.length > 0) {
        this.ScreeningData = Obj4[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.ScreeningData = null;
        this.apiCk = this.apiCk + 1;
      }

      let Obj5 = PatientPhysicalImage.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (Obj5.length > 0) {
        this.PhysicalImageData = Obj5[0];
        this.apiCk = this.apiCk + 1;
      } else {
        this.PhysicalImageData = null;
        this.apiCk = this.apiCk + 1;
      }

      let Obj6 = PatientOpdImage.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      if (Obj6.length > 0) {
        this.OpdImageData = Obj6;
        this.apiCk = this.apiCk + 1;
      } else {
        this.OpdImageData = null;
        this.apiCk = this.apiCk + 1;
      }

      let Obj7 = PatientDoctorNoteOPD.query()
        .where(record => record.datas.hn == hn)
        .get();

      if (Obj7.length > 0) {
        this.DoctorNoteData = Obj7;
        this.apiCk = this.apiCk + 1;
      } else {
        this.DoctorNoteData = null;
        this.apiCk = this.apiCk + 1;
      }
    },
    TextToHtml(txt) {
      if (txt != null && txt != "") {
        String.prototype.replaceAll = function(search, replacement) {
          var target = this;
          return target.split(search).join(replacement);
        };
        let PgNote = txt;
        PgNote = PgNote.replaceAll("\n", "<br>");

        return PgNote;
      } else {
        return "";
      }
    }
  }
})
export default class EmrTreatmentOPD extends Vue {}
</script>

<style lang="scss">
.emr-opd-image {
  display: none;
}
#figure {
  margin-bottom: 0px !important;
}
.img-preview {
  width: 150px;
  border-radius: 0.25rem !important;
}
.img-preview-ipfs {
  width: 100%;
  max-width: 200px;
  border-radius: 0.25rem !important;
}
</style>

